import {Component, OnInit, input} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {Observable} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';
import * as ProfileActions from '../../store/profile.actions';


@Component({
    selector: 'app-profile-media-tag-rank',
    templateUrl: './profile-media-tag-rank.component.html',
    styleUrls: ['./profile-media-tag-rank.component.scss'],
    standalone: false
})
export class ProfileMediaTagRankComponent implements OnInit {

  readonly channelType = input<string>(undefined);
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');
  }

  addProfileAudit(profile: string) {
    this.store.dispatch(
      new ProfileActions.AddAuditCheck({profile: profile, channelType: this.channelType(), redirect: false})
    );
  }

}
